<template>
  <div id="removeclass">
    <modal
      :modal-id="modalId"
      :title="modalTitle"
      :preloader="preloader"
      @submit="submit"
      @close-modal="closeModal"
    >
      <template slot="body">
        <app-overlay-loader v-if="preloader" />
          <VueSignaturePad
            id="signature"
            width="100%"
            height="200px"
            ref="signaturePad"
            :options="{onBegin: () => {$refs.signaturePad.resizeCanvas()}}"
          />
          <div class="mt-2 d-flex  justify-content-end align-items-center" >
            <button @click.prevent="undo" class="btn btn-danger mr-2" >Undo</button>
            <!-- <button @click.prevent="save" class="btn btn-success mr-5" >Save</button> -->
          </div>
        <div class="form-group row align-items-center" >
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("name") }}
          </label>
          <app-input
              id="inputs_name"
              class="col-sm-9"
              type="text"
              v-model="inputs.name"
          />
        </div>
        <div class="form-group row align-items-center" >
          <label for="inputs_designation" class="col-sm-3 mb-0">
            {{ $t("Designation") }}
          </label>
          <app-input
              id="inputs_designation"
              class="col-sm-9"
              type="text"
              v-model="inputs.designation"
          />
        </div>
        <div class="form-group row align-items-center" >
          <label for="inputs_note" class="col-sm-3 mb-0">
            {{ $t("Additional Notes") }}
            <br><small class="text-muted">({{ $t('Optional') }})</small>
          </label>
          <app-input
              id="inputs_note"
              class="col-sm-9"
              type="text"
              v-model="inputs.notes"
          />
        </div>

        <div class="form-group row align-items-center" >
          <label for="inputs_date" class="col-sm-3 mb-0">
            {{ $t("date") }}
          </label>
          <app-input
              id="inputs_date"
              class="col-sm-9"
              type="date"
              v-model="inputs.date"
          />
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../Mixins/ModalMixin";
import * as actions from "../../../../../Config/ApiUrl";
import { axiosPost, axiosGet } from "../../../../../Helpers/AxiosHelper.js";
import AppLibrary from "../../../../../Helpers/AppLibrary";

export default {
  name: "AddModal",
  extends: AppLibrary,
  mixins: [FormMixin, ModalMixin],
  props: {
    taskId: Number,
    formData: {},
  },
  data() {
    return {
      addurl: actions.TASK_ENDORSEMENT,
      preloader: false,
      inputs: {},
      modalId: "endorse-Modal",
      modalTitle: this.$t("endorsement_message"),
    };
  },
  methods: {
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    // save() {
    //   const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
    //   // console.log(file);
    //   console.log(data);
    // },
    submit() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      this.inputs.signature = data;
      this.inputs.task_id = this.taskId;
      this.inputs.form_data = this.formData;

      axiosPost(actions.TASK_ENDORSEMENT, this.inputs)
        .then((res) => {
          this.afterSuccess(res)
        })
        .catch((error) => {
          console.error(error);
          this.afterError()
        })
        .finally(() => {
          if (typeof this.reloadKanbanView === 'function') {
            this.reloadKanbanView();
          }
        });
      // this.save(this.inputs);
    },
    afterSuccess(res) {

      this.preloader = false;
      this.closeModal();
      this.$toastr.s(res.data.message);
      this.$emit("afterSubmitDone");
    },
    afterError() {
      this.preloader = false;
      this.closeModal();
    },
    hideModal() {
      $("#" + this.modalId).modal("hide");
    },
    closeModal() {
      this.hideModal();
      this.$emit("close-modal");
    },
  },

  mounted() {
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
  },
};
</script>
<style>
#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

.container {
  width: "100%";
  padding: 8px 16px;
}

.buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 8px;
}
</style>